import { formatDate, sortMessagesByDate } from "@/helpers/date-helpers";
import { IMessage } from "@/interfaces/message.interface";

/** Chave ordenável AAAA-MM-DD (a exibição continua em DD/MM/AAAA). */
const toDateKey = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const useGroupedMessages = (chatMessages: IMessage[]) => {
  const sortedMessages = sortMessagesByDate(chatMessages);

  const grouped = sortedMessages.reduce(
    (acc, message) => {
      const key = toDateKey(new Date(message.rowDate));
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(message);
      return acc;
    },
    {} as Record<string, IMessage[]>
  );

  const sortedKeys = Object.keys(grouped).sort();

  // Mantém a API do hook: chaves exibíveis em DD/MM/AAAA, já na ordem correta.
  const groupedMessages: Record<string, IMessage[]> = {};
  const sortedDates: string[] = [];

  sortedKeys.forEach((key) => {
    const label = formatDate(new Date(`${key}T00:00:00`));
    groupedMessages[label] = grouped[key];
    sortedDates.push(label);
  });

  return { groupedMessages, sortedDates };
};
